export const defaultSampleRate = 44100 // 44.1khz
